<template>
  <svg width="16"
       height="17"
       viewBox="0 0 16 17"
       fill="url(#paint0_linear_155_2307)"
       xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.99982 13.3016L4.29982 16.1266C4.11649 16.2766 3.91649 16.3472 3.69982 16.3386C3.48315 16.3306 3.29149 16.2682 3.12482 16.1516C2.95815 16.0349 2.82915 15.8766 2.73782 15.6766C2.64582 15.4766 2.64149 15.2599 2.72482 15.0266L4.14982 10.4016L0.524819 7.82656C0.324819 7.69323 0.199819 7.51823 0.149819 7.30156C0.0998186 7.0849 0.108152 6.8849 0.174819 6.70156C0.241485 6.51823 0.358152 6.35556 0.524819 6.21356C0.691485 6.07223 0.891485 6.00156 1.12482 6.00156H5.59982L7.04982 1.20156C7.13315 0.968229 7.26248 0.788896 7.43782 0.663563C7.61248 0.538896 7.79982 0.476562 7.99982 0.476562C8.19982 0.476562 8.38715 0.538896 8.56182 0.663563C8.73715 0.788896 8.86649 0.968229 8.94982 1.20156L10.3998 6.00156H14.8748C15.1082 6.00156 15.3082 6.07223 15.4748 6.21356C15.6415 6.35556 15.7582 6.51823 15.8248 6.70156C15.8915 6.8849 15.8998 7.0849 15.8498 7.30156C15.7998 7.51823 15.6748 7.69323 15.4748 7.82656L11.8498 10.4016L13.2748 15.0266C13.3582 15.2599 13.3542 15.4766 13.2628 15.6766C13.1708 15.8766 13.0415 16.0349 12.8748 16.1516C12.7082 16.2682 12.5165 16.3306 12.2998 16.3386C12.0832 16.3472 11.8832 16.2766 11.6998 16.1266L7.99982 13.3016Z"
      fill="url(#paint0_linear_155_2307)" />
    <defs>
      <linearGradient id="paint0_linear_155_2307"
                      x1="13.3333"
                      y1="0"
                      x2="13.3333"
                      y2="26.6667"
                      gradientUnits="userSpaceOnUse">
        <stop :stop-color="active ? `${$store.state.ui_options.theme?.selected_item_color || '#59BEE5'}` : color" />
        <stop offset="1" :stop-color="active ? `${$store.state.ui_options.theme?.selected_item_color || '#118EBE'}` : color" />
      </linearGradient>
    </defs>
  </svg>
</template>
<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: "#899399"
    }
  }
}
</script>
